import { createDraftSafeSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GlobalState } from '@store'
import { LoadingState, User } from '@types'

interface getClubState {
  loadingStatus: LoadingState
  message: string
  tree?: User[]
  clubList?: User
  foundMember?: User
}

const initialState: getClubState = {
  loadingStatus: 'NOT_STARTED',
  message: ''
}

export type getClubAction = PayloadAction<{
  date: string
  userId: string
}>

const clubSlice = createSlice({
  name: 'club',
  initialState,

  reducers: {
    getClub: (state, _action: getClubAction) => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    getClubSuccess: (state, action) => {
      const data: User[] = action.payload.map((item: User) => ({
        parentId: item.parent,
        id: item._id,
        ...item
      }))
      return {
        ...state,
        tree: data,
        message: '',
        loadingStatus: 'SUCCESS'
      }
    },
    getClubFailed: (state, action) => {
      return {
        ...state,
        loadingStatus: 'FAILED',
        message: action.payload,
        tree: []
      }
    },
    getClubList: state => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    getClubListSuccess: (state, action) => {
      return {
        ...state,
        clubList: action.payload,
        message: '',
        loadingStatus: 'SUCCESS'
      }
    },
    getClubListFailed: (state, action) => {
      return {
        ...state,
        loadingStatus: 'FAILED',
        message: action.payload,
        clubList: undefined
      }
    },
    findMember: (state, _action: PayloadAction<string>) => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    findMemberSuccess: (state, action) => {
      return {
        ...state,
        foundMember: action.payload,
        message: '',
        loadingStatus: 'SUCCESS'
      }
    },
    findMemberFailed: (state, action) => {
      return {
        ...state,
        loadingStatus: 'FAILED',
        message: action.payload,
        foundMember: undefined
      }
    },
    clearClubState: _state => {
      return initialState
    }
  }
})

export const clubLoader = createDraftSafeSelector(
  [(state: GlobalState) => state.club.loadingStatus, (state: GlobalState) => state.club.message],
  (loadingStatus, message) => {
    const isLoading = loadingStatus === 'LOADING'
    const isFailed = loadingStatus === 'FAILED'
    const isSuccess = loadingStatus === 'SUCCESS'
    return { isLoading, isFailed, isSuccess, message }
  }
)
export const getTree = createDraftSafeSelector([(state: GlobalState) => state.club.tree], tree => tree)

export const selectClubList = createDraftSafeSelector(
  [(state: GlobalState) => state.club.clubList],
  clubList => clubList
)

export const selectFoundMember = createDraftSafeSelector(
  [(state: GlobalState) => state.club.foundMember],
  foundMember => foundMember
)

export const {
  getClub,
  getClubSuccess,
  getClubFailed,
  findMember,
  findMemberSuccess,
  findMemberFailed,
  clearClubState,
  getClubList,
  getClubListSuccess,
  getClubListFailed
} = clubSlice.actions
export default clubSlice.reducer
